import { ProFormaFundOwnershipDetailModel } from 'api';
import { GetUniqueSecurityAndFundCombinationParams } from 'pages/Waterfall/types';

const getUniqueSecurityAndOwnerCombination = ({
  fundOwnershipDetail,
  owner,
}: GetUniqueSecurityAndFundCombinationParams) => {
  const uniqueSecurityAndFundCombination = fundOwnershipDetail
    .filter(fod => fod[owner])
    .reduce((acc: ProFormaFundOwnershipDetailModel[], current) => {
      const uniqueIdentifier = `${current.security}-${current[owner]}-${owner}`;
      if (!acc.find(fod => `${fod.security}-${fod[owner]}-${owner}` === uniqueIdentifier)) {
        acc.push(current);
      }
      return acc;
    }, []);

  return uniqueSecurityAndFundCombination;
};

export default getUniqueSecurityAndOwnerCombination;
